export const streamingOptions = [
  { label: "Netflix", value: "Netflix" },
  { label: "Disney+", value: "Disney+" },
  { label: "Peacock", value: "Peacock" },
  { label: "Hotstar", value: "Hotstar" },
];
